/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/

export interface IExpandablePanel {
    readonly id: string;
    readonly isExpanded: boolean;
    expand(): void;
    shrink(): void;
    toggle(): void;
}

